var splitContent = document.querySelectorAll('.split-content');
var mobileLgbt = document.querySelector('section#lgbt');
var services = document.querySelectorAll('.service');
var heroButton = document.querySelector('#hero .btn.red');
var menuBar = document.getElementById('menu-bar');
var mapSection = document.getElementById('map');

// var mapWaypoint = new Waypoint({
//   element: mapSection,
//   offset: 600,
//   // context: mapSection,
//   handler: function(direction) {
//     if (this.element.className.indexOf('scrolled') > -1) {
//       this.element.className = this.element.className.replace(' scrolled', '');
//     } else {
//       this.element.className += ' scrolled';
//     }
//   }
// });

// var mapWaypointBottom = new Waypoint({
//   element: mapSection,
//   offset: -400,
//   // context: mapSection,
//   handler: function(direction) {
//     if (this.element.className.indexOf('scrolled') > -1) {
//       this.element.className = this.element.className.replace(' scrolled', '');
//     } else {
//       this.element.className += ' scrolled';
//     }
//   }
// });


var heroCtaWaypoint = new Waypoint({
  element: heroButton,
  offset: 0,
  handler: function(direction) {
    if (menuBar.className.indexOf('with-cta') > -1) {
      menuBar.className = menuBar.className.replace(' with-cta', '');
    } else {
      menuBar.className += ' with-cta';
    }
  }
});

for (var i = 0; i < splitContent.length; i++) {
  var splitContentWaypoint = new Waypoint({
    element: splitContent[i],
    offset: 280,
    handler: function(direction) {
      if (this.element.className.indexOf('scrolled') > -1) {
        this.element.className = this.element.className.replace(' scrolled', '');
      } else {
        this.element.className += ' scrolled';
      }
    }
  });
}

var mobileLgbtWaypoint = new Waypoint({
  element: mobileLgbt,
  offset: 450,
  handler: function(direction) {
    if (this.element.className.indexOf('scrolled') > -1) {
      this.element.className = this.element.className.replace(' scrolled', '');
    } else {
      this.element.className += ' scrolled';
    }
  }
});

// Scrolling effect for services boxes at various breakpoints
for (var i = 0; i < services.length; i++) {
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  if(w > 767) {
    var servicesWaypoint = new Waypoint({
      element: services[i],
      offset: 725 - ((i % 3) * 100),
      handler: function(direction) {
        var el = this.element;
        if (el.className.indexOf('scrolled') > -1) {
          el.className = el.className.replace(' scrolled', '');
        } else {
          el.className += ' scrolled';
        }
      }
    });
  } else {
    var servicesWaypoint = new Waypoint({
      element: services[i],
      offset: 280,
      handler: function(direction) {
        if (this.element.className.indexOf('scrolled') > -1) {
          this.element.className = this.element.className.replace(' scrolled', '');
        } else {
          this.element.className += ' scrolled';
        }
      }
    });
  }
}

/**
 * Handle removing the scroll class to service box elements on homepage
 * @return {null}
 */
function clearServices(callback) {
  var scrolled = document.querySelectorAll('.service.scrolled');
  for (var i = 0; i < scrolled.length; i++) {
    scrolled[i].className = scrolled[i].className.replace(' scrolled', '');
  }
  if(callback) {
    callback();
  }
}
